import {
  createMultiStyleConfigHelpers,
  MultiStyleType,
  StyleThemingProps,
} from '~/utils/chakraUtils'
import { mergeMultiStyleConfig } from '~/utils/styleHelpers'

import { textStyleKeys } from '@mangovoice/design-system'
import { textStyles } from '@mangovoice/design-system'

export const enum ParkCallMenuItemVariants {
  Available = 'available',
  Unavailable = 'unavailable',
}

const parkCallMenuItemParts = ['container', 'text'] as const

const helpers = createMultiStyleConfigHelpers(parkCallMenuItemParts)
export const ParkCallMenuItemStyle = helpers.defineMultiStyleConfig({
  baseStyle: {
    container: {
      width: 'full',
      alignItems: 'center',
      paddingY: '0.5rem',
      paddingX: '0.75rem',
      gap: '0.5rem',
      borderRadius: '0.5rem',
    },
    text: {
      userSelect: 'none',
      ...textStyles[textStyleKeys.Body1],
      lineHeight: '1.5rem',
    },
  },
  variants: {
    [ParkCallMenuItemVariants.Available]: {
      container: {
        cursor: 'pointer',
        _hover: { backgroundColor: 'bg.muted' },
        _active: { backgroundColor: 'bg.emphasized' },
      },
    },
    [ParkCallMenuItemVariants.Unavailable]: {
      container: {
        cursor: 'default',
      },
    },
  },
})

export const useParkCallMenuItemStyle = (props?: StyleThemingProps) => {
  return mergeMultiStyleConfig(ParkCallMenuItemStyle, props) as MultiStyleType<
    typeof parkCallMenuItemParts
  >
}
